export default "__VITE_ASSET__D4T25TeN__"